<template>
  <div class="home">
    <!-- 固定头 -->
    <!-- <headtop></headtop> -->
    <!-- 主体内容 -->
    <div class="content">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
     <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <!-- 底部 -->
    <Bottom v-if="$store.state.bottomflag==true"></Bottom>
  </div>
</template>

<script>
import headtop from "@/components/Headtop.vue"
import Bottom from "@/components/Bottom.vue"
export default {
  name: 'Home',
  components:{
    headtop,
    Bottom
  },
  data(){
    return{
    }
  },
  mounted(){
  },
  methods:{
  }
}
</script>
<style lang="scss" scoped="scoped">
.home{
  width: 100%;
  height: 100%;
}
.content{
  width: 100%;
  height: 100%;
}

/deep/.el-input{
  margin-left: 10px;
  .el-input__inner{
  height: 30px;

  }
}
</style>
